import { Icon, Spinner } from "@shared/components";
import cx from "classnames";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";

/**
 * @name GameMessage {React.FC}
 * @param className {string}
 * @param translates {Array}
 * @param icon
 * @param iconSettings
 * @param isOnTop {boolean}
 * @param isShowLink {boolean}
 * @param children {ReactNode}
 */
export const GameMessage = ({
  className,
  translates,
  icon,
  iconSettings,
  isOnTop,
  isShowLink,
  children,
}) => {
  const hasIcon = !!icon;
  const intl = useIntl();

  const getMessages = () => {
    return translates.map((translate, index) => {
      switch (translate) {
        case "loading":
          return (
            <span className="game-message__text" key={`${translate}_${index}`}>
              <Spinner />
            </span>
          );
        case "play":
          return (
            <span className="game-message__text" key={`${translate}_${index}`}>
              {intl.formatMessage({
                id: "boilerplate.components.Game.Card.Play",
              })}
            </span>
          );
        case "demo":
          return (
            <span className="game-message__text" key={`${translate}_${index}`}>
              {intl.formatMessage({
                id: "boilerplate.components.Game.Card.Demo",
              })}
            </span>
          );
        case "link":
          return (
            <span className="game-message__text" key={`${translate}_${index}`}>
              {intl.formatMessage({
                id: "boilerplate.components.GameMessage.Link",
              })}
            </span>
          );
        case "error":
          return (
            <span className="game-message__text" key={`${translate}_${index}`}>
              {intl.formatMessage({
                id: "boilerplate.components.GameMessage.Title",
              })}
            </span>
          );
        case "landscape":
          return (
            <span className="game-message__text" key={`${translate}_${index}`}>
              {intl.formatMessage({
                id: "boilerplate.components.GameMessage.Landscape",
              })}
            </span>
          );
        case "portrait":
          return (
            <span className="game-message__text" key={`${translate}_${index}`}>
              {intl.formatMessage({
                id: "boilerplate.components.GameMessage.Portrait",
              })}
            </span>
          );
        case "rotate":
          return (
            <span className="game-message__text" key={`${translate}_${index}`}>
              {intl.formatMessage({
                id: "boilerplate.components.GameMessage.Rotate",
              })}
            </span>
          );
        case "iframeErr":
          return (
            <span
              className="game-message__text"
              key={"boilerplate.components.GameMessage.TitleIframeErrorOne"}
            >
              {intl.formatMessage({
                id: "boilerplate.components.GameMessage.TitleIframeErrorOne",
              })}
            </span>
          );
        default:
          return null;
      }
    });
  };

  return (
    <div
      className={cx("game-message", className, {
        "game-message--onTop": isOnTop,
      })}
    >
      {hasIcon && (
        <Icon {...iconSettings} name={icon} className="game-message__icon" />
      )}

      {getMessages()}
      {children}
      {isShowLink && (
        <Link className="game-message__link" to="/">
          <FormattedMessage id="boilerplate.components.GameMessage.Link" />
        </Link>
      )}
    </div>
  );
};

GameMessage.defaultProps = {
  className: "",
  isOnTop: false,
  isShowLink: false,
  translates: [],
  iconSettings: {},
  icon: null,
};

GameMessage.propTypes = {
  className: PropTypes.string,
  isOnTop: PropTypes.bool,
  isShowLink: PropTypes.bool,
  translates: PropTypes.array,
  iconSettings: PropTypes.object,
  icon: PropTypes.oneOfType([PropTypes.string, () => null]),
};

export default GameMessage;
